const mixin = {
  methods: {
    hasHttpStatusCode (error, status) {
      return error?.response?.status === status
    },

    getErrorData (error) {
      return error?.response?.data || null
    },

    is400BadRequestError (error) {
      return this.hasHttpStatusCode(error, 400)
    },

    is404NotFoundError (error) {
      return this.hasHttpStatusCode(error, 404)
    },

    is405NotAllowedError (error) {
      return this.hasHttpStatusCode(error, 405)
    },

    is409ConflictError (error) {
      return this.hasHttpStatusCode(error, 409)
    }
  }
}


export default mixin
